export function getMaxMinAvg(
  arr: number[]
): {
  low: number;
  high: number;
  avg: number;
} {
  let low = 10000;
  let high = -10000;
  let count = 0;
  let accum = 0;

  arr.forEach((num) => {
    if (num < low) {
      low = num;
    }

    if (num > high) {
      high = num;
    }

    count += 1;
    accum += num;
  });

  return {
    low,
    high,
    avg: accum / count,
  };
}
